import { Injectable } from '@angular/core';
import { HttpServices } from '../../../shared/services/http-service.service';
import { SalvageRequestDTO } from '../models/salvage-request-dto.model';
import { AdminResponseDto } from '../models/adminResponseDto';

@Injectable({
  providedIn: 'root'
})
export class SalvageRequestService {
  constructor(private http: HttpServices) { }
  
  public getSalvageRequest (RequestId: string) {
    return this.http.get('Salvage/GetSalvage/' + RequestId);
  }

  /** POST: add a new hero to the database */
  public addSalvageRequest (salvageRequest: SalvageRequestDTO) {
    return this.http.post('Salvage/AddSalvage', salvageRequest);
  }
  public adminReviewRequest (adminResponseDto:AdminResponseDto ) {
    return this.http.post('Salvage/AdminReviewRequest',adminResponseDto);
  }

}
